import { useEffect, useMemo, useState, type PropsWithChildren } from "react";
import { ThemeContext } from "./ThemeContext";
import type { ITheme } from "@/types/SharedTypes";

interface ThemeProviderProps {
    theme: ITheme;
}
export const ThemeProvider = ({ theme: initialTheme, children }: PropsWithChildren<ThemeProviderProps>) => {
    // whenever the theme changes, we call the applyTheme function
    const [theme, setTheme] = useState<ITheme>(initialTheme);
    useEffect(() => {
        console.log("ThemeProvider: theme changed", theme);
        applyTheme(theme);
    },[theme]);

    const value = useMemo(() => ({ theme, setTheme }), [theme]);
    return (
        <ThemeContext.Provider value={value}>   
            {children}
        </ThemeContext.Provider>
    );
}

const applyTheme = (theme: ITheme) => {
    const root = document.documentElement;
    Object.keys(theme).forEach((key) => {
        // console.log(key, theme[key as keyof ITheme]);
        const value = theme[key as keyof ITheme];
        // assign the value to the root element
        root.style.setProperty(`--${key}`, value ?? "")
    })

};